import * as React from 'react';
import { isFunction } from 'lodash';
import { Root, Trigger } from '@radix-ui/react-dropdown-menu';
import { IconButton } from '../button';
import { OverflowIcon } from '../../icons/overflow-icon';
import { AfterActionCallback, MenuItem, MenuItemProps } from './menu-item';
import { MenuContent } from './menu-content';

type MenuProps = {
  items?: MenuItemProps[];
  children?: React.ReactNode;
  afterAction?: AfterActionCallback;
  trigger?: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
  offset?: number;
};

const defaultTrigger = (
  <IconButton
    presentation="grayTransparent"
    icon={<OverflowIcon />}
    testId="overflow-menu"
  />
);

export const Menu = ({
  items = [],
  children,
  afterAction = () => {},
  trigger = defaultTrigger,
  onOpenChange = () => {},
  offset = 0,
}: MenuProps) => {
  const treatItemsAsRenderFunction = isFunction(items);

  const mapOverItemsArray = () =>
    items.map((item, index) => {
      const props = item;

      return (
        <MenuItem
          {...props}
          key={`menu-item-${index}`}
          afterAction={afterAction}
        />
      );
    });

  return (
    <Root onOpenChange={onOpenChange}>
      <Trigger asChild>{trigger}</Trigger>
      <MenuContent
        sideOffset={offset}
        style={{
          zIndex: 5,
        }}
      >
        {treatItemsAsRenderFunction
          ? items({ afterAction })
          : mapOverItemsArray()}
        {children}
      </MenuContent>
    </Root>
  );
};
